import React, { useContext } from "react";
import { PageContext } from "src/utils/context";

const CtaReferrer = () => {
    const { ctaReferrer } = useContext(PageContext)
    return(
        <input className="block w-full shadow-sm py-3 px-4 placeholder-placeholdergrey focus:ring-darkred focus:border-darkred border-[#e0e0e0] text-lg" type="hidden" name="cta_referrer" id="cta_referrer" value={ctaReferrer} />
    )
}

export default CtaReferrer